import { Autocomplete, TextField } from "@mui/material";
import { fetchDeptApi } from "API/apis/master/getDept";
import { message } from "constants/responses/message";
import { useGlobalContext } from "context/GlobalContext";
import React, { useEffect, useState } from "react";

export const DeptSelector = ({ selectedDept, handleDeptSelection }) => {
  const { setIsInitializing, setError, setIsLoading, setSuccess } =
    useGlobalContext();
  const [options, setOptions] = useState([]);

  useEffect(() => {
    const fetchData = async () => {
      try {
        setIsInitializing(true);

        const { data, status } = await fetchDeptApi();

        if (status !== 200) {
          throw new Error(message.error.generalFailure);
        }

        setOptions(data);
      } catch (error) {
        setError(error.message);
      } finally {
        setIsInitializing(false);
        setIsLoading(false);
        setSuccess("");
        setError("");
      }
    };
    fetchData();
  }, []);
  return (
    <Autocomplete
      disablePortal
      options={options}
      value={options.find((item) => item.id === selectedDept) || null}
      isOptionEqualToValue={(option, value) => option.id === value.id}
      getOptionLabel={(option) => `${option.dept} | ${option.subDept}`}
      getOptionKey={(option) => option.id}
      onChange={(e, newValue) => handleDeptSelection(newValue)}
      renderInput={(params) => (
        <TextField {...params} label="Department" fullWidth />
      )}
    />
  );
};
